import {
  COGNITO_DOMAIN,
  CLIENT_ID,
  LOGIN_REDIRECT_URI,
  LOGOUT_REDIRECT_URI,
} from "./authConfig";

export function login() {
  const url =
    `${COGNITO_DOMAIN}/login` +
    `?client_id=${CLIENT_ID}` +
    `&response_type=token` +
    `&scope=email+openid+profile` +
    `&redirect_uri=${encodeURIComponent(LOGIN_REDIRECT_URI)}`;

  window.location.href = url;
}

export function logout() {
  localStorage.removeItem("idToken");

  const url =
    `${COGNITO_DOMAIN}/logout` +
    `?client_id=${CLIENT_ID}` +
    `&logout_uri=${encodeURIComponent(LOGOUT_REDIRECT_URI)}`;

  window.location.href = url;
}